var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6422 8.24596C22.5537 4.8477 27.4464 4.8477 29.3579 8.24596L43.3087 33.0473C45.1835 36.3803 42.7749 40.4986 38.9508 40.4986H11.0493C7.22514 40.4986 4.81657 36.3803 6.69139 33.0473L20.6422 8.24596ZM27.4998 32.9989C27.4998 34.3796 26.3805 35.4989 24.9998 35.4989C23.6191 35.4989 22.4998 34.3796 22.4998 32.9989C22.4998 31.6182 23.6191 30.4989 24.9998 30.4989C26.3805 30.4989 27.4998 31.6182 27.4998 32.9989ZM24.9998 12.9989C23.6191 12.9989 22.4998 14.1182 22.4998 15.4989V22.9989C22.4998 24.3796 23.6191 25.4989 24.9998 25.4989C26.3805 25.4989 27.4998 24.3796 27.4998 22.9989V15.4989C27.4998 14.1182 26.3805 12.9989 24.9998 12.9989Z",
    fill: "#FF4646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon_warning.605278ad1c0d87c2c4aaeff7031175ba.svg";
export { ForwardRef as ReactComponent };